"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactRouterDom = require("react-router-dom");

var _Auth = require("../../providers/Auth");

var _Config = require("../../providers/Config");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function UnauthorizedRoute(_ref) {
  let Component = _ref.component,
      _ref$redirectTo = _ref.redirectTo,
      redirectTo = _ref$redirectTo === void 0 ? '/' : _ref$redirectTo,
      rest = _objectWithoutPropertiesLoose(_ref, ["component", "redirectTo"]);

  const _useConfig = (0, _Config.useConfig)(),
        appConfig = _useConfig.appConfig;

  const _ref2 = appConfig || {},
        authConfig = _ref2.auth;

  const _ref3 = authConfig || {},
        _ref3$redirectTo = _ref3.redirectTo,
        _redirectTo = _ref3$redirectTo === void 0 ? redirectTo : _ref3$redirectTo;

  const _useAuth = (0, _Auth.useAuth)(),
        auth = _useAuth.auth;

  return /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, _extends({}, rest, {
    render: props => !auth.isAuthenticated ? /*#__PURE__*/_react.default.createElement(Component, props) : /*#__PURE__*/_react.default.createElement(_reactRouterDom.Redirect, {
      to: {
        pathname: _redirectTo,
        search: "from=" + props.location.pathname,
        state: {
          from: props.location
        }
      }
    })
  }));
}

var _default = UnauthorizedRoute;
exports.default = _default;
module.exports = exports.default;